import * as types from "./types";

import {
    getPurchaseInvoicesListAxios,
    deletePurchaseInvoicesAxios,
    postPurchaseInvoicesAxios,
    putPurchaseInvoicesAxios,
    getPurchaseInvoicesByIDAxios,

    getPurchaseInvoiceDocumentList,
    deletePurchaseInvoiceDocument,
    uploadPurchaseInvoiceMultipleDocuments,
    uploadPurchaseInvoiceDocument,
    downloadPurchaseInvoiceDocument
} from "./services";

export async function getPurchaseInvoicesListAction({ commit }) {
    commit(types.LOADING_PURCHASEINVOICES, true);
    try {
        const { data } = await getPurchaseInvoicesListAxios();
        commit(types.GET_PURCHASEINVOICES_LIST, data.result.data);
        return data.result.data;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASEINVOICES, false);
    }
}

export async function removePurchaseInvoicesAction({ commit }, payload) {
    commit(types.LOADING_PURCHASEINVOICES, true);
    try {
        await deletePurchaseInvoicesAxios(payload);
        commit(types.REMOVE_PURCHASEINVOICES, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASEINVOICES, false);
    }
}

export async function addPurchaseInvoicesAction({ commit }, payload) {
    commit(types.LOADING_PURCHASEINVOICES, true);
    try {
        await postPurchaseInvoicesAxios(payload);
        commit(types.ADD_PURCHASEINVOICES, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASEINVOICES, false);
    }
}

export async function updatePurchaseInvoicesAction({ commit }, payload) {
    commit(types.LOADING_PURCHASEINVOICES, true);
    try {
        await putPurchaseInvoicesAxios(payload);
        commit(types.UPDATE_PURCHASEINVOICES, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASEINVOICES, false);
    }
}

export async function getPurchaseInvoicesByIDAction({ commit }, payload) {
    commit(types.LOADING_PURCHASEINVOICES, true);
    try {
        // await getSalesInvoicesByIDAxios(payload);
        // commit(types.GET_SALESORDERSBYID, payload);
        const { data } = await getPurchaseInvoicesByIDAxios(payload);
        commit(types.GET_PURCHASEINVOICESBYID, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASEINVOICES, false);
    }
}


export async function getPurchaseInvoiceDocumentListAction({ commit },id) {
    commit(types.LOADING_PURCHASE_INVOICE_DOCUMENT, true);
    try {
        const { data } = await getPurchaseInvoiceDocumentList(id);
        commit(types.GET_PURCHASE_INVOICE_DOCUMENT_LIST, data.data);
    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_PURCHASE_INVOICE_DOCUMENT, false);
    }
}

export async function removePurchaseInvoicerDocumentAction({ commit }, payload) {
    commit(types.LOADING_PURCHASE_INVOICE_DOCUMENT, true);
    try {
        await deletePurchaseInvoiceDocument(payload);
        commit(types.REMOVE_PURCHASE_INVOICE_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASE_INVOICE_DOCUMENT, false);
    }
}

export async function downloadPurchaseInvoiceDocumentAction({ commit }, payload) {
    commit(types.LOADING_PURCHASE_INVOICE_DOCUMENT, true);
    try {
        await downloadPurchaseInvoiceDocument(payload);
        commit(types.DOWNLOAD_PURCHASE_INVOICE_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASE_INVOICE_DOCUMENT, false);
    }
}


export async function uploadPurchaseInvoiceDocumentAction({ commit }, {payload, referenceId = null, type = null, typeId = null}) {
    commit(types.LOADING_PURCHASE_INVOICE_DOCUMENT, true);
    try {
        await uploadPurchaseInvoiceDocument(payload, referenceId, type, typeId);
        commit(types.ADD_PURCHASE_INVOICE_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASE_INVOICE_DOCUMENT, false);
    }
}


export async function uploadPurchaseInvoiceMultipleDocumentAction({ commit }, {payload, referenceId = null, type = null, typeId = null}) {
    commit(types.LOADING_PURCHASE_INVOICE_DOCUMENT, true);
    try {
        await uploadPurchaseInvoiceMultipleDocuments(payload, referenceId, type, typeId);
        commit(types.ADD_PURCHASE_INVOICE_MULTI_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASE_INVOICE_DOCUMENT, false);
    }
}
